import { useEffect, useState } from 'react';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FormResponseDto } from '../../commons/dtos/form-response.dto';
import { IChatbotAPIPagination } from '../../commons/interfaces/chatbotAPI.interface';
import CustomTable from '../../components/CustomTable';
import Paper from '../../components/Paper';
import FormService from '../../services/form.service';
import tableColumnMetadata from './table.metadata';

const formService = new FormService();

const FormResponse = () => {
  const initialPagination = { page: 1, pageSize: 10, pageCount: 1, totalCount: 1 };

  const params = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParam] = useSearchParams();
  const [statusFilter, setStatusFilter] = useState(searchParams.get('status') || 'PENDING');

  const [formResponses, setFormResponses] = useState<FormResponseDto[]>([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState<IChatbotAPIPagination>(initialPagination);

  useEffect(() => {
    const fetchFormResponse = async () => {
      setLoading(true);

      const uniqueCode: string = params.formTypeId as string;
      const filterParams = searchParams.toString() || 'status=PENDING'; // To set a default value
      const response = await formService.listFormTypeResponse(uniqueCode, page, filterParams);

      setFormResponses(response.data);
      setPagination(response.pagination);
      setLoading(false);
    };

    fetchFormResponse();
  }, [page, params.formTypeId, searchParams]);

  const handleSelectTab = (selectedStatus: string | null) => {
    if (selectedStatus) {
      setSearchParam({ status: selectedStatus });
      setStatusFilter(selectedStatus);
    }
  };

  const handleFooterClick = (value: number) => {
    setPage(page + value);
  };

  const handleClickRow = (formResponse: FormResponseDto) => {
    navigate(`./${formResponse.id}`);
  };

  const footerProps = {
    onClick: handleFooterClick,
    pagination,
    loading
  };

  return (
    <Paper>
      <Row className="justify-content-between mb-4">
        <Col className="d-flex m-auto">
          <span>Solicitudes de formularios</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs id="ticket-table" activeKey={statusFilter} onSelect={handleSelectTab}>
            <Tab eventKey="PENDING" title="PENDIENTE"></Tab>
            <Tab eventKey="APPROVED" title="APROBADO"></Tab>
            <Tab eventKey="REJECTED" title="RECHAZADO"></Tab>
          </Tabs>
        </Col>
      </Row>
      <Row>
        <Col>
          <CustomTable<FormResponseDto>
            data={formResponses}
            columnsMetadata={tableColumnMetadata}
            footerProps={footerProps}
            loading={loading}
            onClickRow={handleClickRow}
          />
        </Col>
      </Row>
    </Paper>
  );
};

export default FormResponse;
